import classNames from 'clsx'
import { node, oneOf, string } from 'prop-types'

import Button from 'views/components/atoms/Button'
import IconCaret from 'views/components/atoms/Icon/IconCaret'

import './ButtonNavigation.scss'

/**
 * This button type used in slider animation
 * and rewrites parent button styles a lot (flex layout used)
 */
const ButtonNavigation = props => {
  const { children, direction, iconSize, className, ...rest } = props

  const IconNav = <IconCaret direction={direction} size={iconSize} />
  const buttonClassname = classNames(
    className,
    'a-Button--navigation',
    `a-Button--navigation__${direction}`
  )

  return (
    <Button {...rest} className={buttonClassname}>
      {IconNav}
      <span className="a-visuallyhidden">{children}</span>
    </Button>
  )
}

ButtonNavigation.propTypes = {
  ...Button.propTypes,
  children: node.isRequired,
  direction: oneOf(['left', 'right', 'up', 'down']),
  iconSize: string,
}

ButtonNavigation.defaultProps = Button.defaultProps

export default ButtonNavigation
